import { Controller } from "@hotwired/stimulus"
import { createConversationSubscription } from "../channels/conversation_channel"
import Tus from "@uppy/tus"
import Russian from '@uppy/locales/lib/ru_RU'
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import { Picker } from 'emoji-picker-element'

export default class extends Controller {
  static values = {
    conversationId: String
  }

  static targets = ["textarea", "emojiContainer"]

  createFile(fileData) {
    const parameters = JSON.stringify({ file: fileData });
    const token = document.getElementsByName("csrf-token")[0].content;

    // Show loading modal
    this.showLoadingModal();

    fetch('/api/v1/files.json', {
      body: parameters,
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json',
        "X-CSRF-Token": token
      },
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Check if file exists by polling the server
        this.checkFileExists(data.file_id, data.url);
      });
  }

  // New method to show loading modal
  showLoadingModal() {
    // Create modal if it doesn't exist
    let modal = document.getElementById('fileLoadingModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'fileLoadingModal';
      modal.className = 'modal fade show';
      modal.style.display = 'block';
      modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100%';
      modal.style.height = '100%';
      modal.style.zIndex = '1050';

      const modalDialog = document.createElement('div');
      modalDialog.className = 'modal-dialog modal-dialog-centered';

      const modalContent = document.createElement('div');
      modalContent.className = 'modal-content';
      modalContent.style.padding = '20px';
      modalContent.style.textAlign = 'center';

      const modalBody = document.createElement('div');
      modalBody.className = 'modal-body';

      const spinner = document.createElement('div');
      spinner.className = 'spinner-border text-primary';
      spinner.setAttribute('role', 'status');

      const loadingText = document.createElement('p');
      loadingText.className = 'mt-2';
      loadingText.textContent = window.locale == "ru" ? 'Загрузка файла...' : 'Loading file...';

      modalBody.appendChild(spinner);
      modalBody.appendChild(loadingText);
      modalContent.appendChild(modalBody);
      modalDialog.appendChild(modalContent);
      modal.appendChild(modalDialog);

      document.body.appendChild(modal);
    } else {
      modal.style.display = 'block';
    }
  }

  // New method to hide loading modal
  hideLoadingModal() {
    const modal = document.getElementById('fileLoadingModal');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  // New method to check if file exists
  checkFileExists(fileId, fileUrl) {
    if (!fileUrl) {
      console.error('File URL is missing');
      this.hideLoadingModal();
      return;
    }

    // Try to fetch the file to check if it exists
    fetch(fileUrl, { method: 'HEAD' })
      .then(response => {
        if (response.ok) {
          // File exists, proceed with sending the message
          this.hideLoadingModal();
          this.sendMessageWithAttachment(fileId);
        } else {
          // File doesn't exist yet, try again after a delay
          setTimeout(() => this.checkFileExists(fileId, fileUrl), 1000);
        }
      })
      .catch(error => {
        // Error occurred, try again after a delay
        console.warn('Error checking file existence:', error);
        setTimeout(() => this.checkFileExists(fileId, fileUrl), 1000);
      });
  }

  sendMessageWithAttachment(attachmentUrl) {
    console.log('Sending message with attachment...', attachmentUrl);

    // Get the form element
    const form = this.element.querySelector('form');

    if (form) {
      const messageInput = form.querySelector('textarea[name="message"]');
      const message = messageInput.value.trim();

      // Send the message via ActionCable
      if (this.subscription) {
        this.subscription.perform("create_conversation_message", {
          message: message || '', // Send empty string if no message text
          attachments: [attachmentUrl]
        });

        // Clear the message input after submission
        messageInput.value = '';
      }
    }
  }

  uploadAttachment(event) {
    event.preventDefault()
    if ($('#upload-link').hasClass('restrict-upload')) return
    const locale = window.locale == "ru" ? Russian : 'en_EN'

    // If we already have an Uppy instance, reuse it by opening modal


    // Create new Uppy instance only if one doesn't exist
    const uppy = new Uppy({
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['image/*']
      },
      autoProceed: false,
      locale: locale
    })
    uppy.use(Tus, { endpoint: window.upload_endpoint, chunkSize: 5 * 1024 * 1024 })
    uppy.use(Dashboard, {
      proudlyDisplayPoweredByUppy: false,
      autoOpenFileEditor: true,
      hideCancelButton: true
    })

    // Store reference to the instance for future reuse
    this.uppyInstance = uppy;

    uppy.on('upload-success', (file, response) => {
      let fileData = {
        title: file.name,
        file_orig_name: file.name,
        file_url: response.uploadURL,
        file_size: file.size,
        file_type: file.meta.type
      }
      this.createFile(fileData);
      uppy.getPlugin('Dashboard').closeModal();
    });

    uppy.getPlugin('Dashboard').openModal();
  }

  connect() {
    console.log("Support chat controller connected:", this.conversationIdValue);
    this.setupChatChannel();
    this.showEmojiPicker = false;
    this.emojiContainer = null;
    this.picker = null;
    if (this.uppyInstance) {
      this.uppyInstance.getPlugin('Dashboard').closeModal();
      this.uppyInstance.close();
      this.uppyInstance = null;
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // Clean up emoji picker if it exists
    this.closeEmojiPicker();
  }

  setupChatChannel() {
    // Only setup the channel if we have a conversation ID
    if (!this.hasConversationIdValue) return;

    // Create subscription using our helper function
    this.subscription = createConversationSubscription(
      this.conversationIdValue,
      {
        connected: this._cableConnected.bind(this),
        disconnected: this._cableDisconnected.bind(this),
        received: this._cableReceived.bind(this)
      }
    );
  }

  _cableConnected() {
    console.log("Connected to support chat channel");
  }

  _cableDisconnected() {
    console.log("Disconnected from support chat channel");
  }

  _cableReceived(data) {
    console.log("Received message:", data);

    if (data.action === 'create_message') {
      this.appendMessage(data.message);
    } else if (data.action === 'delete_message') {
      this.removeMessage(data.message_id);
    }
  }

  toggleEmojiPicker(event) {
    event.preventDefault();

    if (!this.showEmojiPicker) {
      this.showEmojiPicker = true;

      // Create emoji picker container if it doesn't exist
      if (!this.emojiContainer) {
        this.emojiContainer = document.createElement('div');
        this.emojiContainer.className = 'emoji-picker-container';
        this.emojiContainer.style.position = 'absolute';
        this.emojiContainer.style.bottom = '400%';
        this.emojiContainer.style.width = '210px';
        this.emojiContainer.style.height = '210px';
        this.emojiContainer.style.zIndex = '1000';

        // Append to form container
        const formContainer = this.element.querySelector('.support-chat-form-container');
        formContainer.appendChild(this.emojiContainer);

        // Create emoji picker instance
        this.picker = new Picker({
          locale: window.locale == "ru" ? 'ru' : 'en',
          emojiSize: '1.5rem'
        });

        this.emojiContainer.appendChild(this.picker);

        // Add emoji selection event
        this.picker.addEventListener('emoji-click', event => {
          this.addEmoji(event.detail);
        });
      } else {
        this.emojiContainer.style.display = 'block';
      }

      // Add click outside listener
      document.addEventListener('click', this.handleClickOutside.bind(this));

    } else {
      this.closeEmojiPicker();
    }
  }

  handleClickOutside(event) {
    // Check if click is outside the emoji picker
    if (this.emojiContainer && !this.emojiContainer.contains(event.target) &&
      !event.target.closest('.emoji-button')) {
      this.closeEmojiPicker();
    }
  }

  closeEmojiPicker() {
    if (this.showEmojiPicker && this.emojiContainer) {
      this.showEmojiPicker = false;
      this.emojiContainer.style.display = 'none';
    }
  }

  addEmoji(emojiData) {
    if (!emojiData) return;

    const textarea = this.element.querySelector('#conversation-text-editor textarea');
    if (textarea) {
      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
      const text = textarea.value;
      const before = text.substring(0, startPos);
      const after = text.substring(endPos, text.length);

      textarea.value = before + emojiData.unicode + after;
      textarea.focus();
      textarea.selectionStart = startPos + emojiData.unicode.length;
      textarea.selectionEnd = startPos + emojiData.unicode.length;
    }
  }

  appendMessage(messageHTML) {
    const messageData = JSON.parse(messageHTML)
    console.log('Parsed message data:', messageData);

    const chatBody = this.element.querySelector('.support-chat-body');
    const messagesContainer = chatBody.querySelector('#support-chat-messages');

    if (messagesContainer) {
      // Create a new message element
      const messageDiv = document.createElement('div');
      messageDiv.id = `message-${messageData.id}`;
      messageDiv.className = 'support-chat-message';

      // Add appropriate classes based on who sent the message
      if (messageData.user && messageData.user.id) {
        // messageDiv.classList.add(messageData.user.id === currentUserId ? 'support-chat-message-self' : 'support-chat-message-other');
        messageDiv.classList.add('support-chat-message-self');
      }

      // Create the message content
      let messageContent = `
      <div class="msg_right">
        <img class="user_avatar" src="${messageData.user.avatar_url}" alt="" />
        <div class="message d-flex other" id="message-<%= message.id %>">
          <div class="d-flex flex-column">
            <div class="user_name">
              <a>
              ${messageData.user.full_name}
              </a>
            </div>
            <p class="text_body">
              ${messageData.body}
            </p>
            `;
      // Add attachments if any
      if (messageData.attachments && messageData.attachments.length > 0) {
        messageContent += '<div class="message-attachments">';
        messageData.attachments.forEach(attachment => {
          messageContent += `<a class="message-attachment" href="${attachment.url}" target="_blank">`;
          if (attachment.is_image == true) {
            const attachmentId = `image-attachment-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
            messageContent += `
              <div class="image-loading-container" id="loading-${attachmentId}">
                <div class="spinner-border spinner-border-sm text-primary" role="status">
                  <span class="visually-hidden">${window.locale == "ru" ? 'Загрузка...' : 'Loading...'}</span>
                </div>
                <p class="loading-text">${window.locale == "ru" ? 'Загрузка изображения...' : 'Loading image...'}</p>
              </div>
              <img id="${attachmentId}" 
                   src="${attachment.url}" 
                   alt="Attachment" 
                   class="message-attachment-image" 
                   style="max-width: 100%; margin-top: 10px; display: none;"
                   onload="this.style.display='block'; document.getElementById('loading-${attachmentId}').style.display='none';"
                   onerror="this.style.display='none';">
            `;
            // Set up the image loading check to run after the message is added to the DOM
            setTimeout(() => this.checkImageLoaded(attachmentId, attachment.url), 100);
          } else {
            messageContent += `<p class="message-attachment-link" target="_blank">${attachment.name}</p>`;
          }
          messageContent += '</a>';
        });

        messageContent += '</div>';
      }
      messageContent += `</div>
            <div class="message_action d-flex flex-column">
              <span class="time">
              ${new Date(messageData.created_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
              </span>
            </div>
          </div>
      </div>
      `;



      messageDiv.innerHTML = messageContent;

      // Append the new message to the messages container
      messagesContainer.appendChild(messageDiv);

      // Scroll to the bottom to show the new message
      chatBody.scrollTop = chatBody.scrollHeight;
    }
  }

  removeMessage(messageId) {
    const messageElement = this.element.querySelector(`#message-${messageId}`);
    if (messageElement) {
      messageElement.remove();
    }
  }

  toggleChat(event) {
    event.preventDefault();
    this.element.classList.toggle('expanded');

    // Scroll to the bottom when opening chat
    if (this.element.classList.contains('expanded')) {
      const chatBody = this.element.querySelector('.support-chat-body');
      chatBody.scrollTop = chatBody.scrollHeight;
    }
  }

  sendMessage(event, attachments) {
    console.log('Sending message...', attachments);
    event.preventDefault();

    // Get the form element
    const form = this.element.querySelector('form');

    if (form) {
      const messageInput = form.querySelector('textarea[name="message"]');
      const message = messageInput.value.trim();

      if (message) {
        // Send the message via ActionCable instead of form submission
        if (this.subscription) {
          this.subscription.perform("create_conversation_message", {
            message: message,
            attachments: [attachments]
          });

          // Clear the message input after submission
          messageInput.value = '';
        } else {
          // Fallback to regular form submission if subscription isn't available
          form.submit();
          messageInput.value = '';
        }
      }
    }
  }

  // Check if image is loaded
  checkImageLoaded(imageId, imageUrl, retryCount = 0) {
    const maxRetries = 20;
    const img = document.getElementById(imageId);
    const loadingElement = document.getElementById(`loading-${imageId}`);

    if (!img || !loadingElement) return;

    this.checkImageUrlExists(
      imageUrl,
      () => {
        // Image exists and is valid
        img.style.display = 'block';
        loadingElement.style.display = 'none';
        this.reloadImage(img.id)
          .catch(error => {
            console.error('Failed to reload image:', error);
            loadingElement.style.display = 'none';
            img.style.display = 'block';
          });
      },
      () => {
        // Failed to validate image
        loadingElement.innerHTML = `
          <div class="image-error">
            <i class="fas fa-exclamation-circle"></i>
            <p>${window.locale == "ru" ? 'Не удалось загрузить изображение' : 'Failed to load image'}</p>
            <button class="btn btn-sm btn-outline-primary retry-button" 
                    data-image-id="${imageId}" 
                    data-image-url="${imageUrl}"
                    data-action="click->support-chat#retryLoadImage">
              ${window.locale == "ru" ? 'Повторить' : 'Retry'}
            </button>
          </div>
        `;
      },
      retryCount
    );
  }

  // Retry loading an image - Modified to accept event parameter for data-action compatibility
  retryLoadImage(event) {
    event.preventDefault();
    const target = event.target;
    const imageId = target.dataset.imageId;
    const imageUrl = target.dataset.imageUrl;

    this.doRetryImageLoad(imageId, imageUrl);
  }

  // Helper method that does the actual retry work
  doRetryImageLoad(imageId, imageUrl) {
    const img = document.getElementById(imageId);
    const loadingElement = document.getElementById(`loading-${imageId}`);

    if (!img || !loadingElement) return;

    // Reset loading state
    loadingElement.innerHTML = `
      <div class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">${window.locale == "ru" ? 'Загрузка...' : 'Loading...'}</span>
      </div>
      <p class="loading-text">${window.locale == "ru" ? 'Загрузка изображения...' : 'Loading image...'}</p>
    `;
    loadingElement.style.display = 'block';
    img.style.display = 'none';

    // Force reload the image by updating src
    img.src = `${imageUrl}?t=${Date.now()}`;

    // Start checking again
    this.checkImageLoaded(imageId, imageUrl);
  }

  // Check if image URL exists and is actually an image
  checkImageUrlExists(url, onSuccess, onError, retryCount = 0) {
    const maxRetries = 40; // Maximum 30 seconds of checking

    // If we've exceeded max retries, call the error callback
    if (retryCount >= maxRetries) {
      if (onError) onError();
      return;
    }

    // Try to fetch the image URL to check if it exists
    fetch(url, { method: 'HEAD' })
      .then(response => {
        if (response.ok) {
          // Get content type from headers
          const contentType = response.headers.get('content-type');

          // Verify it's actually an image
          if (contentType && contentType.startsWith('image/')) {
            // It's a real image, call success callback
            if (onSuccess) onSuccess();
          } else {
            // It's not an image, retry or fail
            console.warn(`Resource exists but is not an image: ${contentType}`);

            // If we're close to max retries, try with GET to force content type detection
            if (retryCount >= maxRetries - 1) {
              // Last few attempts: try with GET method to better detect content type
              fetch(url)
                .then(fullResponse => {
                  const fullContentType = fullResponse.headers.get('content-type');
                  if (fullContentType && fullContentType.startsWith('image/')) {
                    // It's confirmed to be an image
                    if (onSuccess) onSuccess();
                  } else {
                    // Retry since content type is still not image
                    setTimeout(() => {
                      this.checkImageUrlExists(url, onSuccess, onError, retryCount + 1);
                    }, 1000);
                  }
                })
                .catch(() => {
                  // Error occurred, retry after delay
                  setTimeout(() => {
                    this.checkImageUrlExists(url, onSuccess, onError, retryCount + 1);
                  }, 1000);
                });
            } else {
              // Continue with normal retries
              setTimeout(() => {
                this.checkImageUrlExists(url, onSuccess, onError, retryCount + 1);
              }, 1000);
            }
          }
        } else {
          // URL doesn't exist yet or is not accessible, retry after delay
          setTimeout(() => {
            this.checkImageUrlExists(url, onSuccess, onError, retryCount + 1);
          }, 1000);
        }
      })
      .catch(() => {
        // Error occurred, retry after delay
        setTimeout(() => {
          this.checkImageUrlExists(url, onSuccess, onError, retryCount + 1);
        }, 1000);
      });
  }

  // Helper method to get the controller instance from DOM
  getStimulusController() {
    return this;
  }

  // Reload an image element by forcing a fresh request with a cache-busting timestamp
  reloadImage(imageId) {
    const img = document.getElementById(imageId);
    if (!img) return;

    // Store original src
    const originalSrc = img.src;

    // Add or update cache-busting parameter
    const url = new URL(originalSrc);
    url.searchParams.set('t', Date.now());

    // Set loading state if needed
    img.classList.add('image-reloading');

    // Update src to force reload
    img.src = url.toString();

    // Return a promise that resolves when the image loads
    return new Promise((resolve, reject) => {
      img.onload = () => {
        img.classList.remove('image-reloading');
        resolve(true);
      };
      img.onerror = () => {
        img.classList.remove('image-reloading');
        reject(new Error('Failed to reload image'));
      };
    });
  }
}
